import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import RotatingGrids from './rotatingGrids';
import { theme } from '../../theme/theme';

const KioskLayout: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RotatingGrids />
    </ThemeProvider>
  );
};

export default KioskLayout; 